import { SVGArrowDown } from 'Components/SVGCollection'

import cl from './ScrollIntoViewButton.scss'

{/* TODO: scrollIntoView */ }
const ScrollIntoViewButton: React.SFC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <button
      className={cl.scrollIntoViewButton}
      type="button"
      aria-hidden={true}
      onClick={onClick}
    >
      <SVGArrowDown width={24} height={24} />
    </button>
  )
}

export default ScrollIntoViewButton
